/*------------------------------------*\
    These are reusable utility functions to help keep code DRY. If this gets too long/complex, we should break into smaller files
\*------------------------------------*/

export const roundNumberUp = (num: string | number): number => {
  num = Math.ceil(num as number);
  return num;
};
